import { useMemo } from 'react';

import { cn } from '@/utils';

import { inlineLink } from './Poll.css';
import type { PollChoiceType, PollStyle } from './Poll.types';

interface Props {
  choice: PollChoiceType;
  pollStyle: PollStyle;
  isLast: boolean;
  isInteractive?: boolean;
  isLoading?: boolean;
  isDisabled?: boolean;
  onVote?: () => void;
}

export const PollChoice = ({ choice, pollStyle, isLast, isInteractive, isLoading, isDisabled, onVote }: Props) => {
  const isInline = pollStyle === 'inline';

  const style = useMemo(() => {
    if (pollStyle !== 'unstyled') {
      return { color: 'inherit', textDecoration: 'underline' };
    }
    return { color: 'inherit' };
  }, [pollStyle]);

  if (isInteractive) {
    return (
      <li className={cn(inlineLink, isInline && 'flex gap-2')}>
        <button
          type="button"
          onClick={onVote}
          disabled={isDisabled}
          style={{
            ...style,
            cursor: isDisabled ? 'wait' : 'pointer',
            background: 'none',
            border: 'none',
            padding: 0,
            font: 'inherit',
            opacity: isLoading ? 0.5 : 1,
            transition: 'opacity 0.2s',
          }}
        >
          {choice.label}
        </button>
        {!isLast && isInline && <span style={{ color: 'inherit' }}>|</span>}
      </li>
    );
  }

  return (
    <li className={cn(inlineLink, isInline && 'flex gap-2')}>
      <a
        data-skip-tracking="true"
        rel="noopener noreferrer nofollow"
        style={style}
        target="_blank"
        href={choice.response_url}
      >
        {choice.label}
      </a>

      {!isLast && isInline && <span style={{ color: 'inherit' }}>|</span>}
    </li>
  );
};
